import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import SwiperCore, { Pagination, Zoom, Navigation, Mousewheel } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper.min.css';

// install Swiper modules
SwiperCore.use([Mousewheel, Pagination]);

export default function PDFThumbnailList({ children, ...props }) {
  const [swiper, setSwiper] = useState(null);

  useEffect(() => {
    if (swiper === null) return;

    swiper.slideTo(props.currentPageNumber - 1);
  }, [swiper, props.currentPageNumber]);

  return children.length === 0 ? (
    <div className="term-media-container-slider--empty" />
  ) : (
    <React.Fragment>
      {props.isThumbVisible && (
        <OverlayContainer />
      )}

      <Swiper
        onSwiper={setSwiper}
        onClick={props.setThumbsSwiperClick}
        direction="vertical"
        mousewheel={true}
        watchSlidesProgress={true}
        freeMode={true}
        slidesPerView="auto"
        spaceBetween={20}
        modules={[Mousewheel]}
        style={{
          zIndex: '100',
          visibility: props.isThumbVisible ? 'visible' : 'hidden',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '10.25rem',
          padding: '1rem',
          background: '#f6f6f6',
          boxShadow: '0 2px 2px rgb(0 0 0 / .1)',
        }}
      >
        {React.Children.map(children, (child, index) => (
          <SwiperSlide
            key={index}
            style={{ height: 'auto' }}
          >
            {child}

            <div style={{ textAlign: 'center' }}>
              {index + 1}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </React.Fragment>
  );
};

const OverlayContainer = styled.div`
  z-index: 100; // same as thumbnails container
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgb(0 0 0 / .2);
`;
